import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { bindActionCreators, Dispatch } from 'redux';

import urlService from 'common/services/api/urlService';

import routingService from '../../services/routingService';
import { RootState } from '../../store/rootReducer';

import * as styles from './DevEnvironment.scss';

interface DevEnvironmentProps {
    onPathPush: (path: string) => void;
}

interface DevEnvironmentState {
    environmentUrl: string;
}

class DevEnvironmentConfigComponent extends React.PureComponent<DevEnvironmentProps, DevEnvironmentState> {
    constructor(props: DevEnvironmentProps) {
        super(props);
        const previousUrl: string = sessionStorage.getItem(urlService.getDebugDevUrlKey()) || CONFIG.fallbackDevUrl;
        this.state = {
            environmentUrl: previousUrl,
        };
    }

    handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            environmentUrl: event.target.value,
        });
    };

    handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        const { onPathPush } = this.props;
        sessionStorage.setItem(urlService.getDebugDevUrlKey(), this.state.environmentUrl);
        onPathPush(routingService.getPathFromFullGradingUrl(this.state.environmentUrl));
        event.preventDefault();
    };

    render() {
        return (
            <div className={styles.devEnvironmentWrapper}>
                <form onSubmit={this.handleSubmit}>

                    Test url:
                    <input
                        type="text"
                        defaultValue={this.state.environmentUrl}
                        onChange={this.handleChange}
                        className={styles.devEnvironmentInput}
                    />
                    <input type="submit" value="Submit" />
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState, ownProps: DevEnvironmentProps): DevEnvironmentProps => {
    return ownProps;
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        onPathPush: push,
    },
    dispatch,
);

export default connect<DevEnvironmentProps>(mapStateToProps, mapDispatchToProps)(DevEnvironmentConfigComponent);
